var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// libs
import React, { useEffect } from 'react';
import dayjs from 'dayjs';
// widgets
import { Layout } from './widgets/Layout';
// stores
import useDashboardStore from '@/stores/Dashboard';
import useAccountStore from '@/stores/account';
import useSearchCampaignStore from '@/stores/SearchCampaign';
// helpers
import { isEmpty } from '@/helpers/utils';
// includes
import { getMetricsApi } from '@/includes/api/metrics';
import { listCampaignApi } from '@/includes/api/campaign/list';
// defs
import { AdvertiserDimensions, } from '@local/typedefs/dist/protos/campaign/AdvertiserMetrics';
import { CampaignStatus } from '@local/typedefs/dist/protos/campaign/Campaign';
const Index = () => {
    const { activeCampaigns, setActiveCampaigns, setAggregatedMetrics, setCampaignsPerformanceData, } = useDashboardStore();
    const { clearFilters } = useSearchCampaignStore();
    const { getCurrentAccountId, loggedInAccountDetails } = useAccountStore();
    const loggedInAccountDetailsPrevRef = React.useRef(loggedInAccountDetails);
    useEffect(() => {
        var _a, _b;
        if (((_a = loggedInAccountDetailsPrevRef.current.account) === null || _a === void 0 ? void 0 : _a.accountId) !==
            ((_b = loggedInAccountDetails.account) === null || _b === void 0 ? void 0 : _b.accountId)) {
            fetchActiveCampaigns();
        }
        loggedInAccountDetailsPrevRef.current = loggedInAccountDetails;
    }, [loggedInAccountDetails]);
    const fetchActiveCampaigns = () => __awaiter(void 0, void 0, void 0, function* () {
        const accountId = yield getCurrentAccountId();
        const campaigns = yield listCampaignApi(accountId, [CampaignStatus.CAMPAIGN_STATUS_LIVE], true);
        if (campaigns === null || campaigns === void 0 ? void 0 : campaigns.length) {
            setActiveCampaigns(campaigns);
            // fetch campaign metrics again since we have might have new campaigns
            fetchAggregatedMetrcis(campaigns.map((c) => c.id));
            fetchPerformanceSummary(campaigns.map((c) => c.id));
        }
    });
    const fetchAggregatedMetrcis = (campaignIds) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const accountId = yield getCurrentAccountId();
            const aggregatedMetrics = yield getMetricsApi({
                campaignIds,
                accountId,
            });
            aggregatedMetrics &&
                setAggregatedMetrics((_a = aggregatedMetrics === null || aggregatedMetrics === void 0 ? void 0 : aggregatedMetrics.metrics) === null || _a === void 0 ? void 0 : _a.metricsOnDimension[0].metrics);
        }
        catch (err) {
            if (__DEV__) {
                console.log(err);
            }
        }
    });
    const fetchPerformanceSummary = (campaignIds) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const accountId = yield getCurrentAccountId();
            const performanceMetrics = yield getMetricsApi({
                campaignIds,
                accountId,
                dimensions: [AdvertiserDimensions.DIMENSION_DAY],
                interval: {
                    startTime: dayjs().subtract(7, 'day').toISOString(),
                    endTime: dayjs().subtract(1, 'day').toISOString(),
                },
            });
            performanceMetrics &&
                setCampaignsPerformanceData(performanceMetrics.metrics.metricsOnDimension);
        }
        catch (err) {
            if (__DEV__) {
                console.log(err);
            }
        }
    });
    React.useEffect(() => {
        // if activeCampaigns are not present
        if (isEmpty(activeCampaigns)) {
            fetchActiveCampaigns();
        }
        /*
        When a user clicks on 'Show All' in the budget warning Nudge,
        it redirects to the campaign list with the selected exhausted budget campaigns.
        Therefore, to reset the filters when the user is on the homepage,
        we need to call the 'clearFilters' method.
        */
        clearFilters();
    }, []);
    return React.createElement(Layout, null);
};
export default Index;
